import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    View,
    FlatList,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
} from "react-native";


import {moderateScale} from '../../../../../tools/Scaling';


import HMActionBar from "../../../../../customviews/HMActionBar";


import i18n from '../../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../../tools/Tools";
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";

import {typeExport} from "../../../../../redux/store/type";

import HMLoading from "../../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import store from "../../../../../redux/store";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import HMAlert from "../../../../../customviews/HMAlert";

let container = null;

import {connect} from "react-redux";
import HMIcon from "../../../../../customviews/HMIcon";

import HMTextInput from "../../../../../customviews/HMTextInput";
import HMButton from "../../../../../customviews/HMButton";
import axios from "axios";
import Toast from "../../../../../customviews/toast";
import PathFile from "../../../../../assets/PathFile";

class AddPatternMyStateScreen extends Component {


    constructor(props) {
        super(props);
        container = this;


        global.G_ListPattern = null;
        global.G_ListWidget = null;
        let {item} = props.route.params;
        // global.G_ListPattern = item ? item.l : null;
        // global.G_ListWidget = item ? item.l : null;
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //
        // }
        this.state = {
            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: Platform.OS === "web" ?  viewportWidth : typeExport._WIDTH,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            arraySelectCheckBoxGender: [],
            namePattern: item ? item.name : "",
        };
        this.props.navigation.addListener('focus', () => {


                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
            }
        )
        this.props.navigation.addListener('blur', () => {
        })


    }


    componentDidMount() {
        let {item} = this.props.route.params;

        if (item && item.id)
            this.getAddPattern();

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                )


            })
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };
        paramss = Tools.addAllParams(paramss);
        this.props.callService(
            typeExport.urlApplyScreen,
            paramss,
            typeExport.TypeGetApplyScreen,
            "POST",
            this.state
        );

    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
        }
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;
        let list = this.props.route.params ? this.props.route.params.list : null;
        let _params = this.props.route.params;
        let item = _params.item;

        //  let item = _params && _params.item ? JSON.parse(_params.item) : null;
        return (


            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        {/*  <HMGradient
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                                flex: 1,
                                // alignItems: 'center'
                            }}
                            color1={"#4cee1c"}
                            color2={"#0012ee"}

                            x1="0%" y1="0%" x2="0%" y2="100%"

                        />*/}

                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != "MahalemaArak"}
                            // menu
                            back={typeExport._NameApp != "MahalemaArak"}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == "MahalemaArak"}
                            funcExit={() => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            }}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : '')) : null}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[{marginStart: moderateScale(48)}]}

                        />

                        {
                            (!this.props.DataSplashScreen.NoInternetDialogShahrdar) && (!this.props.DataSplashScreen.isLoadingShahrdar) ?
                                null
                                :
                                <View
                                    style={{
                                        width: "100%",
                                        //  flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: this.props.DataSplashScreen.NoInternetDialogShahrdar ? Colors.red : Colors.white,
                                        alignSelf: 'center',
                                        padding: moderateScale(6)
                                    }}
                                >
                                    {this.props.DataSplashScreen.NoInternetDialogShahrdar ?
                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.white,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={"خطایی رخ داده مجددا تلاش نمایید"}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.getDataServerSplash()

                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(2),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Update')}
                                                    //  text={"ثبت و بستن تیکت"}
                                                    type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                        :

                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={i18n.t('constant.Update')}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                        </View>
                                    }
                                </View>


                        }


                        <View
                            style={{
                                flex: 1,
                                // alignItems: 'center'
                            }}
                        >
                            {
                                this.props.results == null && this.props.isLoading && request_server ?
                                    <HMLoading/>

                                    :
                                    <ScrollView
                                        style={{
                                            //   backgroundColor:"#dd2dee"
                                        }}>
                                        <View
                                            style={{
                                                width: "100%",

                                                //      backgroundColor: "#048700",
                                                //position:'absolute',
                                                // flexDirection: "row",
                                                //   flexWrap: 'wrap',
                                                //flex: 1,

                                                // flexGrow: 1,
                                                //  alignItems: 'center',
                                                //   justifyContent: 'center',
                                                marginTop: moderateScale(12),
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,

                                            }}>

                                            <View
                                                onPress={() => {

                                                    // NavigationService.navigateParams("ListOperatorApplyScreen", {
                                                    //     //  NavigationService.navigateParams("ListUserChatScreen", {
                                                    //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                    //     data: item, item: item,
                                                    // })
                                                }
                                                }

                                                style={{
                                                    alignItems: 'center',
                                                    flexDirection: 'row',
                                                    marginVertical: moderateScale(4)
                                                }}
                                            >

                                                {/*  <HMIcon name={"speedometer"} style={{
                                                    fontSize: moderateScale(20),
                                                    color: Colors.blue,
                                                    marginHorizontal: moderateScale(4),
                                                    //  marginTop: moderateScale(3)
                                                }}/>*/}
                                                <HMIcon

                                                    //source={require('../../../../../assets/img/success.png')}
                                                    //source={PathFile.image.background}
                                                    //svg={PathFile.svg.add}
                                                    type={"svg"}
                                                    source={PathFile.svg.speedometer}
                                                    height={moderateScale(20)}
                                                    width={moderateScale(20)}
                                                    style={{
                                                        // fontSize: moderateScale(20),
                                                        // color: Colors.blue,
                                                        // marginHorizontal: moderateScale(4),
                                                        marginRight: moderateScale(4),
                                                        marginLeft: moderateScale(4),
                                                        //  marginTop: moderateScale(3)
                                                    }}

                                                />


                                                <HMTextView
                                                    text={"نام الگو"} type={"bold"}
                                                    style={{
                                                        color: "#113956",
                                                        //marginHorizontal: moderateScale(6),
                                                        fontSize: moderateScale(14),
                                                        textAlign: 'center',

                                                    }}/>

                                                <HMTextInput value={this.state.namePattern}
                                                             onChangeText={(text) => this.setState({namePattern: text}, () => {
                                                                 //  this.getJsonMap()

                                                             })}
                                                             _height={40}
                                                             _width={180}
                                                    //  autoFocus
                                                    //  placeholder={i18n.t('constant.filter')}
                                                             placeholder={"نام الگو"}
                                                             NoShowPlaceholder
                                                    //باتد_width={'80%'}
                                                    // icon={"md-person"}
                                                             styleRoot={{
                                                                 flex: 1,
                                                                 borderRadius: moderateScale(8),
                                                                 borderColor: "#303030",
                                                                 borderWidth: moderateScale(1),
                                                                 marginHorizontal: moderateScale(8)
                                                             }}
                                                             style={{
                                                                 fontSize: moderateScale(13),

                                                                 // marginTop: moderateScale(6)
                                                             }} underlineColorAndroid="transparent"


                                                />
                                            </View>

                                            <TouchableOpacity
                                                onPress={() => {

                                                    NavigationService.navigateParams("AccessReportMyStateScreen", {
                                                        //  NavigationService.navigateParams("ListUserChatScreen", {
                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                        data: item, item: item,
                                                        itemExtra: this.state.results?.patterns?.[0]?.places,
                                                        name: this.state.namePattern
                                                    })
                                                }
                                                }

                                                style={{
                                                    alignItems: 'center',
                                                    flexDirection: 'row',
                                                    marginVertical: moderateScale(4)
                                                }}
                                            >

                                                {/*  <HMIcon
                                                    type={"FontAwesome"}
                                                    name={"angle-double-down"}
                                                    style={{
                                                        fontSize: moderateScale(20),
                                                        color: Colors.blue,
                                                        marginHorizontal: moderateScale(4),
                                                        //  marginTop: moderateScale(3)
                                                    }}/>
*/}
                                                <HMIcon

                                                    //source={require('../../../../../assets/img/success.png')}
                                                    //source={PathFile.image.background}
                                                    //svg={PathFile.svg.add}
                                                    type={"svg"}
                                                    source={PathFile.svg.down_chevron}
                                                    height={moderateScale(20)}
                                                    width={moderateScale(20)}
                                                    style={{
                                                        // fontSize: moderateScale(20),
                                                        // color: Colors.blue,
                                                        // marginHorizontal: moderateScale(4),
                                                        marginRight: moderateScale(4),
                                                        marginLeft: moderateScale(4),
                                                        //  marginTop: moderateScale(3)
                                                    }}

                                                />

                                                <HMTextView
                                                    text={"دسترسی به گزارشات گروههای کاری"} type={"bold"}
                                                    style={{
                                                        color: Colors.blackLight,
                                                        //marginHorizontal: moderateScale(6),
                                                        fontSize: moderateScale(14),
                                                        textAlign: 'center',

                                                    }}/>

                                            </TouchableOpacity>

                                            <TouchableOpacity
                                                onPress={() => {
                                                    NavigationService.navigateParams("SettingReportMyStateScreen", {
                                                        //  NavigationService.navigateParams("ListUserChatScreen", {
                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                        data: item, item: item,
                                                        itemExtra: this.state.results?.patterns?.[0]?.widgets,
                                                        itemExtraSelected: this.state.results?.patterns?.[0]?.widget_list,


                                                    })
                                                }
                                                }

                                                style={{
                                                    alignItems: 'center',
                                                    flexDirection: 'row',
                                                    marginVertical: moderateScale(4)
                                                }}
                                            >

                                                {/*     <HMIcon
                                                    type={"FontAwesome"}
                                                    name={"angle-double-down"}
                                                    style={{
                                                        fontSize: moderateScale(20),
                                                        color: Colors.blue,
                                                        marginHorizontal: moderateScale(4),
                                                        //  marginTop: moderateScale(3)
                                                    }}/>
*/}

                                                <HMIcon

                                                    //source={require('../../../../../assets/img/success.png')}
                                                    //source={PathFile.image.background}
                                                    //svg={PathFile.svg.add}
                                                    type={"svg"}
                                                    source={PathFile.svg.down_chevron}
                                                    height={moderateScale(20)}
                                                    width={moderateScale(20)}
                                                    style={{
                                                        // fontSize: moderateScale(20),
                                                        // color: Colors.blue,
                                                        // marginHorizontal: moderateScale(4),
                                                        marginRight: moderateScale(4),
                                                        marginLeft: moderateScale(4),
                                                        //  marginTop: moderateScale(3)
                                                    }}

                                                />

                                                <HMTextView
                                                    text={"تنظیمات گزارشک درون داشبورد"} type={"bold"}
                                                    style={{
                                                        color: Colors.blackLight,
                                                        //marginHorizontal: moderateScale(6),
                                                        fontSize: moderateScale(14),
                                                        textAlign: 'center',

                                                    }}/>

                                            </TouchableOpacity>


                                            <View style={{
                                                flexDirection: "row",
                                                width: moderateScale(200),
                                                alignItems: "center",
                                                justifyContent: "center",
                                                alignSelf: "center",
                                                marginVertical: moderateScale(10)
                                            }}>
                                                <HMButton
                                                    text={"ذخیره"} style={{
                                                    width: moderateScale(80),
                                                    backgroundColor: "#164A70",
                                                    borderRadius: moderateScale(16),
                                                }}
                                                    onPress={() => {
                                                        let {namePattern} = this.state;
                                                        if (Tools.checkInputLessCharacter(namePattern)) {
                                                            this.setAddPattern()
                                                        }
                                                        else {
                                                            HMAlert(
                                                                i18n.t('constant.message'),
                                                                "الگو باید بیشتر از دو کاراکتر باشد",
                                                                [
                                                                    {
                                                                        text: i18n.t('constant.ok'), onPress: () => {

                                                                        }


                                                                    },

                                                                ],
                                                                {cancelable: true}
                                                            )
                                                        }
                                                    }
                                                    }
                                                />
                                                <HMButton
                                                    text={"انصراف"}
                                                    style={{
                                                        width: moderateScale(80),
                                                        backgroundColor: "#D9534F",
                                                        borderRadius: moderateScale(16),

                                                    }}
                                                    onPress={() => {
                                                        NavigationService.Pop();
                                                    }
                                                    }
                                                />
                                            </View>

                                        </View>
                                    </ScrollView>


                            }

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }


    onPressSelectCheckBox(item, name, check) {

        let idx = container.state.arraySelectCheckBoxGender.findIndex(obj => obj.id === item.id);
        let arr = container.state.arraySelectCheckBoxGender;

        if (idx !== -1) {
            arr.splice(idx, 1)

            // container.setState({
            //         arraySelected: arr
            //     },
            //
            //     () => {
            //         //  container.state.arraySelected.slice(container.state.indexFilter, 1)
            //         container.state.arraySelected.push({
            //             index: container.state.indexFilter,
            //             data: data,
            //             id: data.id,
            //             value: data.name,
            //             type: container.state.typeFilter
            //         })
            //     }
            // )

        } else {
            container.state.arraySelectCheckBoxGender.push(item)
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }


        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
            },
            () => {
            })
    }

    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }

    setAddPattern(func) {
        let {item} = this.props.route.params;

        let ListPattern, ListWidget = null;
        // if (global.G_ListPattern)
        //     ListPattern = (global.G_ListPattern).filter(a => a.add === true);
        ListPattern = global.G_ListPattern;

        // if (global.G_ListWidget)
        //     ListWidget = (global.G_ListWidget).filter(a => a.add === true);
        ListWidget = global.G_ListWidget;

        //console.log(ListPattern, ListWidget, global.G_ListPattern, global.G_ListWidget)
        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "SavePattern");
        formData.append('place_ids', ListPattern && ListPattern.length > 0 ? JSON.stringify(ListPattern) : null);
        formData.append('widget_ids', ListWidget && ListWidget.length > 0 ? JSON.stringify(ListWidget) : null);
        formData.append('name', this.state.namePattern);
        formData.append('id', item && item.id ? item.id : 0);
        formData.append('lang', i18n.locale);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('tokenLaravel', container.props.DataSplashScreen.tokenLaravel);
        //  formData.append('record', itemParams.RequestID);


        container.requestServer(
            formData, (item) => {

                container.setState({

                    // listWidgets: item && item.widgets && item.widgets.length > 0 ? item.widgets : [],
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {
                    HMAlert(
                        i18n.t('constant.message'),
                        item.message ? item.message : "با موفقیت ثبت شد",
                        [
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                    global.G_DataDashboard = true;
                                    NavigationService.Pop();
                                    //func ? func() : null
                                }


                            },

                        ],
                        {cancelable: true}
                    )

                })
            }, false
        );
    }

    getAddPattern(func) {
        let {item} = this.props.route.params;

        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetDashboardPattern");

        //formData.append('name', this.state.namePattern);
        // formData.append('ids[]', []);
        formData.append('lang', i18n.locale);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('tokenLaravel', container.props.DataSplashScreen.tokenLaravel);
        //  formData.append('record', itemParams.RequestID);

        if (item && item.id) {
            formData.append('with_places', 1);
            formData.append('with_widgets', 1);

            // let arr = [];
            // arr.push(item.id)
            // formData.append('ids[]', arr);
        }
        Tools.addAllFormData(formData,true);

        container.requestServer(
            formData, (item) => {

                container.setState({

                    results: item,
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {

                    //alert(item.success)
                    //func ? func() : null
                })
            }, false
        );
    }

    requestServer(formData, func, noLoading) {


        container.setState({
                //ShowImage:true
                isLoading: !noLoading,
                NoInternetDialog: false,
                // results: null
            },
            () => {
            })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);

        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    // global.G_DataDashboard = true;
                    // NavigationService.Pop();
                    func ? func(data.result) : null;

                    // container.getDataServerSplash()
                }
                else {
                    Toast.show({
                        // type: 'success | error | info',
                        type: 'custom_info',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: data.message ? data.message : "سرور با مشکل مواجه شد مجددا تلاش نمایید",
                        visibilityTime: 4000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                    /*    HMAlert(
                            i18n.t('constant.message'),
                            data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                    }


                                },

                            ],
                            {cancelable: true}
                        )*/
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            console.log('error', e)

            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
        })
    }
}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(AddPatternMyStateScreen);
